/* Component in the Callsheet2 component to display the Callsheet2 Locations */
import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import styles from "../../../styles/Callsheets.module.css";
import Location from './Location2';

const LocationsPage2 = ({callsheet, setShow, scenes}) => {
    const {
        basecamp_name,
        basecamp_address,
        basecamp_parking_n_notes,
        nearest_hospital,
        hospital_address_line_1,
        hospital_address_line_2,
        hospital_address_line_3,
    } = callsheet || {};
    // const [showMapHos, setShowMapHos] = useState(false);
    // const [showMapBase, setShowMapBase] = useState(false);
    // const [showMapLoc, setShowMapLoc] = useState(false);
    // const hospital_address = `${nearest_hospital}, ${hospital_address_line_1}, ${hospital_address_line_2}, ${hospital_address_line_3}, ${hospital_address_line_4}`;  
    // const basecamp_map_address = `${basecamp_name}, ${basecamp_address}`; 
    
  return (
    <div>
        <div className='mt-3'>
        <div className='d-none d-md-block mt-5'>
        <h4 className={`mt-3 pl-3 py-0 ${styles.SubTitleSpan }`} 
        style={{ textTransform: 'uppercase' }}>Locations</h4>
        </div>
        <div className='d-block d-md-none'>
        <div className={`mb-3 text-center ${styles.SubTitleSpan }`}>
        <span className={`float-right ${styles.Close }`} onClick={() => setShow(false) } >Close</span> 
        <h4 className={`pl-5 text-center`} 
        style={{ textTransform: 'uppercase'}} >Locations</h4>
        </div>
        </div>
        <div className={`d-none d-md-block`}>
        <Row style={{ textTransform: 'uppercase' }} 
        className={`mt-2 mx-0  ${styles.TitleBox}`} >
            <Col xs={1}></Col>
            <Col className={`${styles.TitleBox2} px-0 mx-0`} xs={5} md={5} >
            <p className='my-0 py-0 pl-3'><span className='d-none d-sm-inline-block'>Name -</span> Address</p>
            </Col>
            <Col className={`${styles.TitleBox2} px-0 mx-0`} xs={6} md={6} >
            <p className='my-0 py-0 pl-3'><span className='d-none d-sm-inline-block'>Parking, Directions &</span> Notes</p>
            </Col>
        </Row>
        </div>
        <div className={`d-block d-md-none`}>
        <Row style={{ textTransform: 'uppercase' }} 
        className={`mt-2 mx-0  ${styles.TitleBox}`} >
            <Col className={`${styles.TitleBox2} px-0 mx-0`} xs={6} md={5} >
            <p className='my-0 py-0 pl-4'> Address</p>
            </Col>
            <Col className={`${styles.TitleBox2} px-0 mx-0`} xs={6} md={6} >
            <p className='my-0 py-0 pl-1'> Notes</p>
            </Col>
        </Row>
        </div>
        {/* hos */}
        <div className='d-none d-md-block ' >
        {hospital_address_line_1 || nearest_hospital ? (
            <Row 
            style={{ backgroundColor: '#f6fffe' }}
            className='px-3 '>
            <Col className={`mx-0 px-0 ${styles.BorderLoc}`} xs={1} >
            <p></p>
            </Col>
            <Col className={`mx-0 px-1 px-md-3  ${styles.BorderLoc}`} xs={11}>
            <p className={`mb-0 ${styles.BoldBase}`} >Nearest Hospital</p>
            <p className={`mb-0 ${styles.Bold}`} >{nearest_hospital}</p>
            <p className='mb-0'>
            {hospital_address_line_1  && <span>{hospital_address_line_1},</span>}
            {hospital_address_line_2  && <span> {hospital_address_line_2},</span>}
            {hospital_address_line_3  && <span> {hospital_address_line_3},</span>}
            </p>
            </Col>
            </Row>
        ) : (
            ""
        )}
        </div>
        {/* base */}
        {basecamp_address || basecamp_name ? (
            <Row 
            style={{ backgroundColor: 'rgb(254 249 254)' }}
            className='px-3 '>
            <Col className={`mx-0 px-0 ${styles.BorderLoc}`} xs={1} >
            </Col>
            <Col className={`mx-0 px-1 px-md-3  ${styles.BorderLoc}`} xs={5}>
            <p className={`mb-0 ${styles.BoldBase}`} >Basecamp</p>
            <p className={`mb-0 ${styles.Bold}`} >{basecamp_name}</p>
            <p className='mb-0'>{basecamp_address}</p>
            </Col>
            <Col className={`mx-0 px-1 px-md-3 d-flex align-items-center
                 ${styles.BorderLoc}`} xs={6} >
            <p className='mb-0'>{basecamp_parking_n_notes}</p>
            </Col>
            </Row>
        ) : (
            ""
        )}
       {/* NEW */}
       {/* scenes */}
        <Row>
            <Col >                   
            {scenes?.results?.length ? (
                scenes.results.map((scene, index) => (
            <Location
            index={index}
            scene={scene}
            key={scene.id}
            style={{
                backgroundColor: (index % 3 === 0)
                    ? '#f6fffe' : (index % 2 === 0) ?
                        'rgb(246 254 245)' : 'rgb(252 246 251)'
                }}
             />
                ))) : ("")}
            </Col>
        </Row>
        </div>
    </div>
  )
}

export default LocationsPage2